import { useEffect, useState } from "react";

const KEY = "dv-theme";
export const getTheme = () => (typeof window !== "undefined" && window.localStorage.getItem(KEY)) || "light";

export const applyTheme = (theme) => {
  const dark = theme === "dark";
  document.documentElement.classList.toggle("dv-dark", dark);
  document.documentElement.style.colorScheme = dark ? "dark" : "light";
};

export const resetTheme = () => {
  document.documentElement.classList.remove("dv-dark");
  document.documentElement.style.colorScheme = "light";
};

export const useTheme = () => {
  const [theme, setThemeState] = useState(getTheme);
  useEffect(() => {
    applyTheme(theme);
    const onStorage = (e) => { if (e.key === KEY) setThemeState(e.newValue || "light"); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [theme]);
  const setTheme = (t) => { window.localStorage.setItem(KEY, t); setThemeState(t); window.dispatchEvent(new Event("dv:theme")); };
  return [theme, setTheme];
};
